export const SET_MONGO_LOGGER = 'bo-paye/mongo-logger/SET_MONGO_LOGGER'

const initialState = {
  enabled: false,
  slowQueryThresholdMs: 1000,
  csvFileExists: false,
  csvFilePath: '',
  csvOutputDir: '',
}

export default function mongoLoggerModule(state = initialState, action) {
  switch (action.type) {
    case SET_MONGO_LOGGER:
      return { ...state, ...action.value }
    default:
      return state
  }
}
